/**
 * ★ VY-c1 — lista de motivos COMPACTA no cabeçalho da coluna do funil. Puro.
 *
 * O cabeçalho fica fora do corpo rolável; com 8 motivos ele comia a altura da coluna (2 cartões inteiros em
 * 1280×720 — medido). Por padrão aparecem os 3 MAIORES; "+N motivos" expande para todos e recolhe de novo.
 * Os `n` de cada motivo vêm da lista inteira de leads da coluna — aqui só se escolhe quantas LINHAS mostrar.
 * Ordenação por contagem, ESTÁVEL no empate (quem veio antes fica antes); a entrada não é mutada.
 */
export const MOTIVOS_VISIVEIS = 3;

const lista = (motivos) => (Array.isArray(motivos) ? motivos : []);

export function motivosVisiveis(motivos, expandido) {
  const ordenados = [...lista(motivos)].sort((a, b) => (b?.n ?? 0) - (a?.n ?? 0));
  return expandido ? ordenados : ordenados.slice(0, MOTIVOS_VISIVEIS);
}

export const temMaisMotivos = (motivos) => lista(motivos).length > MOTIVOS_VISIVEIS;

export function rotuloMaisMotivos(motivos) {
  const n = Math.max(0, lista(motivos).length - MOTIVOS_VISIVEIS);
  return `+${n} motivo${n === 1 ? '' : 's'}`;
}
